export default function BankDetailsSection() {
  return (
    <div>
    </div>
  );
}
